import { observable, IObservableArray } from "mobx";
import { copy, copyArray } from "../utils/data";

export class Address {
  @observable city: string;
  @observable province: string;
  @observable state: string;
  @observable street1: string;
  @observable street2: string;

  constructor(addr?: Address) {
    this.city = this.province = this.state = this.street1 = this.street2 = "";
    if (addr) {
      copy(addr, this);
    }
  }
}

export class Location {
  @observable idHash: string;
  @observable address: Address;
  @observable phone: string;
  @observable website: string;

  constructor(loc?: Location) {
    this.idHash = this.phone = this.website = "";
    this.address = new Address();
    if (loc) {
      copy(loc, this, ["address"]);
      this.address = new Address(loc.address);
    }
  }
}

export class Organization {
  @observable idHash: string;
  @observable appProcess: string;
  @observable applicationEmail: string;
  @observable contactEmail: string;
  @observable contractType: string;
  @observable desiredSkillMult: number;
  @observable disclaimer: string;
  @observable layoutFormat: string;
  @observable locations: Array<Location>;
  @observable name: string;
  @observable requiredSkillMult: number;
  @observable softSkillMult: number;

  constructor(org?: Organization) {
    this.idHash = this.appProcess = this.applicationEmail = this.contactEmail = this.contractType = this.disclaimer = this.layoutFormat = this.name = "";
    this.desiredSkillMult = this.requiredSkillMult = this.softSkillMult = 1;
    this.locations = new Array<Location>();
    if (org) {
      copy(org, this, ["locations"]);
      if (org.locations) {
        copyArray(org.locations, this.locations, (l) => { return new Location(l); })
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/models/organization.ts